import { Formatter } from 'shared'

const ParkServiceSelector = ({ park, base }) => {
  if (!park.hasServices)
    return <p>No services available...</p>;

  return (
    <div className="park-service-selector">
      <h5 className="park_service_selector__title subpanel-title">Services</h5>
      <div className="park-service-selector__list">
        <table className="table table-sm table-borderless table-font-sm">
          <tbody>
            {
              park.services.map((service) => (
                <tr key={service.id}>
                  <td>{service.name}</td>
                  <td>{Formatter.amountFromCents(service.amount, { free: true })}</td>
                  <td>{Formatter.duration(service.duration)}</td>
                  <td>
                    <Link
                      className="btn btn-outline-primary btn-sm"
                      to={`${base}/${park.uid}::reserve:${service.id}`}
                    >
                      Select
                    </Link>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ParkServiceSelector;
